export default "__VITE_ASSET__G1PygFJa__";